import { render, staticRenderFns } from "./FromTo.vue?vue&type=template&id=a8d3d472"
import script from "./FromTo.vue?vue&type=script&lang=js"
export * from "./FromTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports